<template>
  <ul ref="wrapper" class="flex flex-row overflow-hidden">
    <slot />
  </ul>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref, watch } from 'vue'

const props = defineProps<{
  currentItem: number
}>()

const wrapper = ref<HTMLElement | null>()

function scrollToItem(behavior: 'smooth' | 'instant') {
  if (!wrapper.value) {
    return
  }

  const items = Array.from(wrapper.value.children)

  items[props.currentItem].scrollIntoView({
    behavior,
    block: 'nearest',
    inline: 'start',
  })
}

function scrollSmooth() {
  scrollToItem('smooth')
}
function scrollInstant() {
  scrollToItem('instant')
}

onMounted(() => {
  window.addEventListener('resize', scrollInstant)
})

onUnmounted(() => {
  window.removeEventListener('resize', scrollInstant)
})

watch(() => props.currentItem, scrollSmooth, { immediate: true })
</script>
